import { render } from "./UpdateActionResponseComponent.vue?vue&type=template&id=6b01b096"
import script from "./UpdateActionResponseComponent.vue?vue&type=script&lang=js"
export * from "./UpdateActionResponseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__